export default __webpack_public_path__ + "static/media/25.d62e5d04.mp3";